<template>
  <div v-if="loadApplication !== undefined" style="height: 100%">
    <div v-if="loadApplication" style="height: 100%">
      <slot></slot>
    </div>
    <div v-else>
      <div class="no-login">
        <h2>You don't have permission to use this application</h2>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'AuthCheck',
  computed: mapState({
    loadApplication: state => state.loadApplication
  })
};
</script>

<style></style>
